// import React, { createContext, useContext, useState } from "react";
// import { crudData } from "../services/apiService";

// const OrdersContext = createContext();

// export const OrdersProvider = ({ children }) => {
//     const [sumAmountOrders, setSumAmountOrders] = useState(null);

//     const fetchUserSumAmountOrders = () => {
//         const user = JSON.parse(localStorage.getItem("userData"));
//         if (user) {
//             const params = {
//                 mode: "listOrdersByClient",
//                 LG_CLIID: user.LG_CLIID,
//             };

//             crudData(params, "CommandeManager.php").then((res) => {
//                 console.log("Réponse complète du backend:", res);
//                 console.log("Valeur récupérée de sumAmountOrders:", res.data?.data?.sumAmountOrders);
//                 const value = Number(res.data?.data?.sumAmountOrders) || 0;
//                 setSumAmountOrders(value);
            
//             });
//         }
//     };

//     return (
//         <OrdersContext.Provider
//             value={{ sumAmountOrders, fetchUserSumAmountOrders }}
//         >
//             {children}
//         </OrdersContext.Provider>
//     );
// };

// export const useOrdersContext = () => useContext(OrdersContext);

import React, { createContext, useContext, useState } from "react";
import { crudData } from "../services/apiService";

const OrdersContext = createContext();

export const OrdersProvider = ({ children }) => {
    const [sumAmountOrders, setSumAmountOrders] = useState(0); // 0 au lieu de null
    const [isOrdersLoading, setIsOrdersLoading] = useState(false);

    const fetchUserSumAmountOrders = (startDate = null, endDate = null) => {
        const user = JSON.parse(localStorage.getItem("userData"));
        if (!user || !user.LG_CLIID) return; // ← vérifier que le user existe

        const params = {
            mode: "listOrdersByClient",
            LG_CLIID: user.LG_CLIID,
        };

        // Ajouter les dates si fournies
        if (startDate) params["DT_BEGIN"] = startDate
        if (endDate)   params["DT_END"]   = endDate

        setIsOrdersLoading(true);
        crudData(params, "CommandeManager.php")
            .then((res) => {
                const value = Number(res.data?.data?.sumAmountOrders) || 0;
                setSumAmountOrders(value);
            })
            .catch((err) => {
                console.error("Erreur fetchUserSumAmountOrders:", err)
                setSumAmountOrders(0) // 0 en cas d'erreur
            })
            .finally(() => {
                setIsOrdersLoading(false);
            });
    };

    return (
        <OrdersContext.Provider value={{ sumAmountOrders, fetchUserSumAmountOrders, isOrdersLoading }}>
            {children}
        </OrdersContext.Provider>
    );
};

export const useOrdersContext = () => useContext(OrdersContext);